<template>
  <div>
    <v-card :shaped="shaped" :elevation="elevation" outlined>
      <v-alert dark :color="bgColor" :border="border" :icon="icon" :style="{'color':color}">
        <slot>
          <strong>{{ title }}</strong>
          <br>{{ text }}
        </slot>
      </v-alert>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      default:'mdi-vuetify'
    },
    border: {
      default: 'left'
    },
    title: {
      default:''
    },
    text: {
      default: ''
    },
    bgColor: {
      default: 'black'
    },
    elevation: {
      default: 24
    },
    shaped: {
      default: false
    },
    color:{
      default:'white'
    }
}
}
</script>

<style>

</style>